import { Box, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CusTooltip from '../../../../../components/material-ui/CusTooltip';
import TypographyText from '../../../../../components/material-ui/table/TypographyText';

export default function CascadeHelp({ cascadeHelp = {} }) {
  const { t } = useTranslation();

  const reactId = cascadeHelp.reactId;
  const myCascadeHelp = useMemo(() => {
    const myCascadeHelp = { ...cascadeHelp };
    delete myCascadeHelp.reactId;
    return myCascadeHelp;
  }, [reactId]);

  return (
    <Stack direction={'row'} gap={0.5}>
      <Typography variant="h6">
        {t('List of gateways for replenishment in foreign currency')}
      </Typography>
      <CusTooltip
        text={
          <Stack gap={1}>
            <Stack>
              <Typography>
                {t('The sequence of gateways determines the priority of their use.')}
              </Typography>
              <Typography>{t('Only one gateway per cryptocurrency is allowed.')}</Typography>
              <Typography>{t('Available gateways:')}</Typography>
            </Stack>
            <Stack gap={0.5}>
              {Object.keys(myCascadeHelp).map((gateKey) => {
                const gateInfo = myCascadeHelp[gateKey] || {};
                const methods = Object.keys(gateInfo.methods || {}) || [];
                return (
                  <Box key={gateKey} gap={0.5} alignItems={'center'}>
                    <TypographyText>{gateInfo.name} -</TypographyText>
                    <TypographyText fontWeight={800}>{gateKey} (</TypographyText>
                    {methods.map((currency, curIndx) => {
                      const currencies = gateInfo.methods[currency] || [];

                      return (
                        <React.Fragment key={gateKey + currency} alignItems={'center'}>
                          <TypographyText fontWeight={600}>{currency}</TypographyText>:
                          {currencies.map((type, typeIndx) => {
                            const isLastMethod = curIndx == methods.length - 1;
                            const isLastCurrency = typeIndx == currencies.length - 1;

                            return (
                              <React.Fragment key={gateInfo.code + currency + type}>
                                <TypographyText>
                                  {type}
                                  {isLastMethod ? '' : isLastCurrency ? ';' : ','}
                                </TypographyText>{' '}
                              </React.Fragment>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}
                    )
                  </Box>
                );
              })}
            </Stack>
          </Stack>
        }
      />
    </Stack>
  );
}
